/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_Wants_AccessInputs */



/**
* | output |
* | --- |
* | "wants to access your Archon account" |
*
* @param {Oauth_Wants_AccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_wants_access = /** @type {((inputs?: Oauth_Wants_AccessInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_Wants_AccessInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("souhaite accéder à votre compte Archon")
	if (locale === "es") return /** @type {LocalizedString} */ ("quiere acceder a su cuenta de Archon")
	if (locale === "pt") return /** @type {LocalizedString} */ ("deseja acessar sua conta Archon")
	if (locale === "it") return /** @type {LocalizedString} */ ("desidera accedere al tuo account Archon")
	return /** @type {LocalizedString} */ ("wants to access your Archon account")
});